import { Flex, FlexItem, H4 } from '@bigcommerce/big-design';
import { StyledComments } from './StyledComponents';

export function OrderComment({ header, children }) {
	return (
		<FlexItem>
			<Flex>
				<H4 margin="small" marginLeft="none">
					{header}:
				</H4>
				<StyledComments>{children}</StyledComments>
			</Flex>
		</FlexItem>
	);
}
